import { useState } from "react";

const AutoCompleteSelect = ({
  options = [],
  labelKey = "label",
  valueKey = "nid", // ✅ Use numeric ID now (matches what Drupal expects)
  placeholder = "Select an option",
  onSelect,
  width = "100%",
}) => {
  const [query, setQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim() === "") {
      setFilteredOptions([]);
    } else {
      const filtered = options.filter((item) =>
        item[labelKey].toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  };

  const handleSelect = (item) => {
    setSelectedValue(item[valueKey]); // store ID for internal state
    setQuery(item[labelKey]); // display readable text in the input
    setFilteredOptions([]);
    if (onSelect) onSelect(item); // ✅ return full selected object
  };

  return (
    <div style={{ position: "relative", width }}>
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder={placeholder}
        required
        className="autocomplete"
        style={{ width: "100%", padding: "10px", fontSize: "16px" }}
      />
      {filteredOptions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            width: "100%",
            background: "#fff",
            border: "1px solid #ccc",
            fontSize: "16px",
            listStyleType: "none",
            padding: "0",
            margin: "0",
            overflowY: "auto",
            zIndex: 10,
            maxHeight: "200px",
          }}
        >
          {filteredOptions.map((item) => (
            <li
              key={item[valueKey]}
              onClick={() => handleSelect(item)}
              style={{
                padding: "10px 16px",
                cursor: "pointer",
              }}
            >
              {item[labelKey]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteSelect;
